export default () => {
  return [
    {
      label: 'Pwr_I',
      unit: '',
      display: false,
      fullform: 'Power Input',
      yAxis: 'Decimal',
      loading: false
    },
    {
      label: 'Bat_V',
      unit: 'V',
      display: false,
      fullform: 'Battery Voltage',
      yAxis: 'Voltage',
      loading: false
    },
    {
      label: 'VFD_OP',
      unit: 'kW',
      display: false,
      fullform: 'VFD Output Power',
      yAxis: 'Power',
      loading: false
    },
    {
      label: 'VFD_OF',
      unit: 'Hz',
      display: true,
      fullform: 'VFD Output Frequency',
      yAxis: 'Frequency',
      loading: false
    },
    {
      label: 'R_Ph_V',
      unit: 'V',
      display: false,
      fullform: 'R Phase Voltage',
      yAxis: 'Voltage',
      loading: false
    },
    {
      label: 'VFD_DCV',
      unit: 'V',
      display: false,
      fullform: 'DC Bus Voltage',
      yAxis: 'Voltage',
      loading: false
    },
    {
      label: 'Rsn_Lst_Trp',
      unit: '',
      display: false,
      fullform: 'Reason for last trip',
      yAxis: 'Fault/Status',
      loading: false
    },
    {
      label: 'Amb_T',
      unit: '°C',
      display: false,
      fullform: 'Ambient Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'Bat_CC',
      unit: 'A',
      display: false,
      fullform: 'Battery Charging Current',
      yAxis: 'Current',
      loading: false
    },
    {
      label: 'Room_1_H',
      unit: '%',
      display: false,
      fullform: 'Room 1 Humidity',
      yAxis: 'Humidity',
      loading: false
    },
    {
      label: 'CRUN_Count',
      unit: '',
      display: false,
      fullform: 'C run count',
      yAxis: 'Decimal',
      loading: false
    },
    {
      label: 'Signal_st',
      unit: 'dBm',
      display: false,
      fullform: 'Signal Strength',
      yAxis: 'Signal Strength',
      loading: false
    },
    {
      label: 'TES_Charge',
      unit: '%',
      display: false,
      fullform: 'TES Charge',
      yAxis: 'Percentage',
      loading: false
    },
    {
      label: 'Dis_P',
      unit: 'PSI',
      display: false,
      fullform: 'Discharge Pressure',
      yAxis: 'Pressure',
      loading: false
    },
    {
      label: 'S_Cnsmptn',
      unit: 'kWh',
      display: false,
      fullform: 'Solar Energy Consumption',
      yAxis: 'Energy',
      loading: false
    },
    {
      label: 'G_Cnsmptn',
      unit: 'kWh',
      display: false,
      fullform: 'Grid Energy Consumption',
      yAxis: 'Energy',
      loading: false
    },
    {
      label: 'Solar_IC',
      unit: 'A',
      display: false,
      fullform: 'Solar input Current',
      yAxis: 'Current',
      loading: false
    },
    {
      label: 'Bat_LC',
      unit: 'A',
      display: false,
      fullform: 'Battery Load Current',
      yAxis: 'Current',
      loading: false
    },
    {
      label: 'VFD_OC',
      unit: 'A',
      display: false,
      fullform: 'VFD Output Current',
      yAxis: 'Current',
      loading: false
    },
    {
      label: 'Y_Ph_V',
      unit: 'V',
      display: false,
      fullform: 'Y Phase Voltage',
      yAxis: 'Voltage',
      loading: false
    },
    {
      label: 'B_Ph_V',
      unit: 'V',
      display: false,
      fullform: 'B Phase Voltage',
      yAxis: 'Voltage',
      loading: false
    },
    {
      label: 'Solar_Th_V',
      unit: 'V',
      display: false,
      fullform: 'Solar voltage threshold',
      yAxis: 'Voltage',
      loading: false
    },
    {
      label: 'Room_2_T',
      unit: '°C',
      display: false,
      fullform: 'Room 2 Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'TES1_T',
      unit: '°C',
      display: false,
      fullform: 'TES 1 Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'TES2_T',
      unit: '°C',
      display: false,
      fullform: 'TES 2 Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'TES3_T',
      unit: '°C',
      display: false,
      fullform: 'TES 3 Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'TES4_T',
      unit: '°C',
      display: false,
      fullform: 'TES 4 Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'TES5_T',
      unit: '°C',
      display: false,
      fullform: 'TES 5 Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'TES6_T',
      unit: '°C',
      display: false,
      fullform: 'TES 6 Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'Door_Stat',
      unit: '',
      display: false,
      fullform: 'Door Status',
      yAxis: 'Fault/Status',
      loading: false
    },
    {
      label: 'Ref_Flt',
      unit: '',
      display: false,
      fullform: 'Ref. faults',
      yAxis: 'Fault/Status',
      loading: false
    },
    {
      label: 'R_01',
      unit: '',
      display: false,
      fullform: 'R-01 CDU F1',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_02',
      unit: '',
      display: false,
      fullform: 'R-02 CDU F2',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_03',
      unit: '',
      display: false,
      fullform: 'R-03 CDU F3',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_04',
      unit: '',
      display: false,
      fullform: 'R-04 CDU F4',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_05_Buck',
      unit: '',
      display: false,
      fullform: 'R-05 FCU F1',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_06',
      unit: '',
      display: false,
      fullform: 'R-06 FCU F2',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_07_DG_off',
      unit: '',
      display: false,
      fullform: 'R-07 FCU F3',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_08_DG_on',
      unit: '',
      display: false,
      fullform: 'R-08 Humidifier',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_09',
      unit: '',
      display: false,
      fullform: 'R-09 TV4',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_10',
      unit: '',
      display: false,
      fullform: 'R-10 TV3',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_11',
      unit: '',
      display: false,
      fullform: 'R-11 TV2',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_12',
      unit: '',
      display: false,
      fullform: 'R-12 TV1',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_13_HTR',
      unit: '',
      display: false,
      fullform: 'R-13 FV',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_14_HUM',
      unit: '',
      display: false,
      fullform: 'R-14 DG ON',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_15_PBF',
      unit: '',
      display: false,
      fullform: 'R-15 DG OFF',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_16_TV',
      unit: '',
      display: false,
      fullform: 'R-16 HTR',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_17_FV',
      unit: '',
      display: false,
      fullform: 'R-17 PBF',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_18_FCF_1',
      unit: '',
      display: false,
      fullform: 'R-18 BUCK',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_18_FCF_2',
      unit: '',
      display: false,
      fullform: 'R-19 RG',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'R_20_CDF_2',
      unit: '',
      display: false,
      fullform: 'R-20 FCU F4',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'Crun_Stat',
      unit: '',
      display: false,
      fullform: 'Crun Status',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'RG_Rel_Stat',
      unit: '',
      display: false,
      fullform: 'SPR Status',
      yAxis: 'Hex',
      loading: false
    },
    {
      label: 'Room_1_T',
      unit: '°C',
      display: true,
      fullform: 'Room 1 Temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'Set_T',
      unit: '°C',
      display: true,
      fullform: 'Set Temperature',
      yAxis: 'Temperature',
      loading: false
    }
  ];
};
